import React from "react";
import { Button, Modal } from "react-bootstrap";
const DeleteModal = (props) => {
  return (
    <React.Fragment>
      <Modal
        show={props.show}
        onHide={() => {
          props.handleClose();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete {props.type}: {props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure, you want to delete this {props.type}?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              props.handleClose();
            }}
          >
            Close
          </Button>
          <Button
            variant="primary"
            style={{
              position: "relative",
            }}
            onClick={() => {
              props.handleDelete(false);
              props.handleClose();
            }}
          >
            {" "}
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
export default DeleteModal;
